export default "__VITE_ASSET__B3Rdc$PZ__"